import { ErrorReporter } from 'src/error/ErrorReporter'
import { UserSession } from 'src/auth/SessionHolder'
import { detect } from 'detect-browser'
import { BrowserErrorContext } from 'src/api/defs/BrowserErrorContext.type'

export type UnexpectedAppError = {
    content: string
    stacktrace: string
}

export class ErrorHandler {
    constructor(
        private readonly reporter: ErrorReporter,
        private storage: Storage,
        private session: UserSession,
        private getUserName: () => string | null,
        private window: Window
    ) {}

    private getStorageContent = (): string => {
        return JSON.stringify(this.storage)
    }

    private getCtx = (): BrowserErrorContext => {
        const brow = detect()

        const browser = brow
            ? `${brow.name}, ${brow.version}, ${brow.os}, ${brow.type}`
            : 'could-not-detect'

        const screen = this.window.screen
        const screenSize = `width=${screen.width}, height=${screen.height}`
        return {
            browser,
            localStorage: this.getStorageContent(),
            location: this.window.location.href,
            screenSize,
            sessionId: this.session.getPersistentSessionId(),
            username: this.getUserName() || undefined
        }
    }

    handle = (error: UnexpectedAppError) => {
        this.reporter.report({
            error: error.content,
            stacktrace: error.stacktrace,
            context: this.getCtx()
        })
    }
}
